import { Reducer } from "redux";
import {
    SET_ZIP_FILE,
    SET_XLSX_FILE,
    SET_ZIP_MESSAGE,
    SET_XLSX_MESSAGE,
    RESET_ZIP_FILE,
    RESET_XLSX_FILE,
    SET_CSV_FILE,
    SET_CSV_MESSAGE,
    RESET_CSV_FILE,
} from "../actions/filesActions";

export interface FilesState {
    zipFile: File | undefined;
    xlsxFile: File | undefined;
    csvFile: File | undefined;
    zipMessage: string;
    xlsxMessage: string;
    csvMessage: string;
}

const messageInit = "Drag and drop file here or click to select";

const initialState: FilesState = {
    zipFile: undefined,
    xlsxFile: undefined,
    csvFile: undefined,
    zipMessage: messageInit,
    xlsxMessage: messageInit,
    csvMessage: messageInit,
};

export const filesReducer: Reducer<FilesState> = (
    state: FilesState = initialState,
    action: any
): FilesState => {
    switch (action.type) {
        case SET_ZIP_FILE:
            return {
                ...state,
                zipFile: action.file,
            };
        case SET_XLSX_FILE:
            return {
                ...state,
                xlsxFile: action.file,
            };
        case SET_CSV_FILE:
            return {
                ...state,
                csvFile: action.file
            }
        case SET_ZIP_MESSAGE:
            return {
                ...state,
                zipMessage: action.msg,
            };
        case SET_XLSX_MESSAGE:
            return {
                ...state,
                xlsxMessage: action.msg,
            };
        case SET_CSV_MESSAGE:
            return {
                ...state,
                csvMessage: action.msg,
            };
        case RESET_ZIP_FILE:
            return {
                ...state,
                zipFile: undefined,
                zipMessage: messageInit,
            };
        case RESET_XLSX_FILE:
            return {
                ...state,
                xlsxFile: undefined,
                xlsxMessage: messageInit,
            };
        case RESET_CSV_FILE:
            return {
                ...state,
                csvFile: undefined,
                csvMessage: messageInit,
            };
        default:
            return state;
    }
};
